import React, { useEffect } from "react";
import qs from "query-string";
import { useLocation, useParams } from "react-router-dom";

import {
  updateCampaingClicks,
  updateRecipientStatus,
} from "api/marketing/campaigns";

const useObserveLinkClicks = () => {
  const location = useLocation();
  const { id: businessUid } = useParams();
  const queryString = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    const updateClicks = async () => {
      if (queryString && queryString.campUid && queryString.cuid) {
        await updateCampaingClicks(businessUid, queryString);
        await updateRecipientStatus(businessUid, queryString);
      }
    };
    updateClicks();
  }, []);
};

export default useObserveLinkClicks;
